import React from 'react';
import Impact from 'templates/impact';

const ImpactPage = () => (
  <Impact />
);

export default ImpactPage;
